import { Card } from "react-bootstrap";
import * as Styled from "./QuoteCard.styled";

interface Props {
    text: string;
}

const QuoteCard = ({ text }: Props) => {
    return (
        <Styled.CardContainer>
            <Card.Body>
                <Card.Text>{text}</Card.Text>
            </Card.Body>
        </Styled.CardContainer>
    );
};

export default QuoteCard;
